"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMainMenuState = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const createMainMenuCharacterSelectState_1 = require("./createMainMenuCharacterSelectState");
const createMainMenuState = ({ mainMenuCharacterIDs, }) => new pixel_pigeon_1.State({
    characterCreateState: null,
    characterCustomizeState: null,
    characterSelectState: (0, createMainMenuCharacterSelectState_1.createMainMenuCharacterSelectState)({ page: 0 }),
    mainMenuCharacterIDs,
});
exports.createMainMenuState = createMainMenuState;
